import React from "react"
import trending_up from "assets/svg/trending-up.svg"
import rightArrowIcon from "assets/svg/chevron-right.svg"

type Props = {
  percentage: number
  rate: number
  title: string
  message: string
  view?: () => void
}
const ShiftRateCard: React.FC<Props> = ({
  percentage,
  rate,
  title,
  message,
}) => {
  return (
    <div className="border-slate-200 border rounded-lg flex flex-col gap-2 w-full p-4">
      <div className="flex items-center gap-2">
        <p className="text-slate-900 font-bold text-sm">{percentage}%</p>
        <button
          className={`flex items-center justify-center px-2 py-1 gap-1 text-[#1F704B] text-sm ${
            rate < 0 ? "bg-[#FEF2F2]" : "bg-[#DCFCE7]"
          } min-w-[56px] rounded-full`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className={`w-4 h-4 transition-transform duration-300 ${
              rate < 0 ? "text-[#E7000B] rotate-180" : "text-green-700"
            }`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
            />
          </svg>

          <span
            className={`text-[12px] font-bold ${
              rate < 0 ? "text-[#E7000B]" : "text-green-700"
            } font-bold`}
          >
            {rate}%
          </span>
        </button>
      </div>
      <p className="text-slate-900 font-bold text-base">{title}</p>
      <div className="text-slate-500 text-xs">{message}</div>
    </div>
  )
}
export default ShiftRateCard
